module.exports = __webpack_public_path__ + "board.fc7bd86a.png";